module.exports = __webpack_public_path__ + "img/jifen.9c948a31.png";